module.exports = __webpack_public_path__ + "static/media/20170501-DSC02560-13_Small.ede33805.jpg";